import { Component, Input } from '@angular/core';
import { getCurrentFiscalYear } from '../../../shared/helpers/get-current-fiscal-year';
import { ProjectModel } from '../../../../hub_schema/hubTypes';

@Component({
    selector: 'app-financials-container',
    styleUrl: './financials-container.component.scss',
    templateUrl: './financials-container.component.html',
    standalone: false
})
export class FinancialsContainerComponent {
    @Input()
    public project: ProjectModel;
}
